import { Card, CardContent, Typography, Box, } from "@mui/material";

const ProjectDashboardProgress = ({ progressData }) => {

  return (
    <Card
      sx={{
        width: "97%",
        borderRadius: 3,
        boxShadow: 3,
        height: "200px",
        bgcolor: "#fff",

      }}
    >
      <CardContent
        sx={{
          display: "flex",
          flexDirection: "column",

        }}
      >
        <Typography
          variant="subtitle2"
          sx={{
            fontWeight: 600,
            // mb: 1,
            color: "#243465",
          }}
        >
          Progress Indicator
        </Typography>

        <Box sx={{
          display: "flex",
          flexDirection: "column",
          maxHeight: "300px", // adjust height as needed
          overflowY: "auto",  // enable vertical scrolling
          "&::-webkit-scrollbar": {
            display: "none", // hide scrollbar for Chrome, Safari, Edge
          },
          "-ms-overflow-style": "none", // hide scrollbar for IE, Edge
          "scrollbar-width": "none", // hide scrollbar for Firefox
        }}>
          {(progressData || []).map((item, i) => {
            const percentage =
              typeof item.completion_percentage === "string"
                ? parseInt(item.completion_percentage.replace("%", ""), 10)
                : item.completion_percentage;

            return (
              <Box
                key={i}
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  gap: 2,
                  marginTop: 1,
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <Box sx={{ display: "flex", justifyContent: "flex-start" }}>
                    <Typography
                      variant="caption"
                      fontWeight={600}
                      color="text.primary"
                      sx={{ fontSize: "12px" }}
                    >
                      {item.milestone}
                    </Typography>
                  </Box>
                  <Typography
                    variant="caption"
                    sx={{
                      fontWeight: 600,
                      color: item.color,
                    }}
                  >
                    {item.status} ({percentage}%)
                  </Typography>
                </Box>
              </Box>
            );
          })}
        </Box>
      </CardContent>
    </Card>
  );
};

export default ProjectDashboardProgress;

